// extracted by mini-css-extract-plugin
module.exports = {"Main":"MarkdownContent_Main__w7T4y"};